export default __webpack_public_path__ + "static/GT-America-Standard-Regular-9827f01affeaeb3c6df2f5afd6bc722e.woff";